<template>
    <div>
        <b-navbar toggleable="lg" fixed="top">
            <b-navbar-brand>
                <router-link class="navbar-brand" :to="{ name: 'Home'}">
                    <img class="mx-1" alt="logo" width=35 src="../assets/logo.svg">
                    <span class="ml-2 font-weight-bold">AKARI TAKADA</span>
                </router-link>
            </b-navbar-brand>
            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
            <b-collapse id="nav-collapse" is-nav>
                <b-navbar-nav class="ml-auto">
                    <b-nav-item><router-link class="nav-effect" exact-active-class="active" :to="{ name: 'Home'}" exact>{{$t("pageTitle.home")}}</router-link></b-nav-item>
                    <b-nav-item><router-link class="nav-effect" exact-active-class="active" :to="{ name: 'Design'}" exact>{{$t("pageTitle.design")}}</router-link></b-nav-item>
                    <!-- <b-nav-item><router-link class="nav-effect" exact-active-class="active" :to="{ name: 'CV'}" exact>{{$t("pageTitle.cv")}}</router-link></b-nav-item> -->
                    <!-- <btnLang v-on:click="switchLocale()"></btnLang> -->
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>
    </div>
    
</template>

<script>
// const btnLang = () => import('../components/button/btnLang.vue')
import { BNavbar, BNavItem, BNavbarBrand, BNavbarToggle, BNavbarNav } from 'bootstrap-vue'

export default {
    name: 'Header',
    components: {
        // 'btnLang': btnLang,
        BNavbar,
        BNavItem, 
        BNavbarBrand, 
        BNavbarToggle, 
        BNavbarNav
    }
}
</script>

<style lang="scss" scoped>
</style>